export enum DeliveryMethodTypes {
    Email = 1,
    Sms = 2,
}

export enum PromotionPackageResponseCodes {
    Success = 0,
    FormatInvalid = 1,
    GeneralError = 2,
    PackageWasNotFound = 3,
    PackageIsNotActive = 4,
    PackageIsExpired = 5,
    ContactWasNotFound = 6,
    ContactIsNotAdmin = 7,
    SmsServiceNotAvailiable = 8,
    SendSmsFailed = 9,
    NoTwoFaCodeWasSetToContact = 10,
    TwoFaCodeWasInvalid = 11,
    DDOSBlock = 12,
    FlowTokenNotValid = 13,
    MaxSmsReached = 14,
}

export interface PromotionPackageEstateEntity {
    promotionPackageID: number;
    estateTypeID: number;
    estateTypeName: string;
    catalogNumber: string;
    amount: number;
    percentageDiscount: number;
    price: number;
    remarks: string;
    startDateByMonths: number;
    endDateByMonths: number;
    isActive: boolean;
    createdDate: string;
    modifiedDate: string;
    rowGuid: string;
}

export interface PromotionPackageEntity {
    promotionPackageID: number;
    name: string;
    remarks: string;
    description: string;
    expiryDate: string | null;
    validityOffer: number;
    timeScheduleID: number;
    totalPrice: number;
    totalPriceWithDiscount: number;
    priceOfferDiscountReasonID: number | null;
    infoJson: string;
    isActive: boolean;
    createdDate: string;
    modifiedDate: string;
    rowGuid: string;
    estates: PromotionPackageEstateEntity[];
}

export interface PromotionPackageCustomerContactEntity {
    customerID: number;
    customerName: string;
    customerToken: string;
    contactID: number;
    contactName: string;
    contactEmail: string;
    contactToken: string;
}

export interface ValidatePromotionPackageResponseEntity {
    response: PromotionPackageResponseCodes;
    message: string;
    flowToken: string;
    infoJson: string;
}

// Shape of ValidatePromotionPackageResponseEntity.infoJson once JSON.parse'd.
export interface PromotionPackageInfoJson {
    description: string;
    promoTitle: string;
    promoHeader: string;
    notes: string[];
}

export interface PromotionPackageSimpleResponseEntity {
    response: PromotionPackageResponseCodes;
    message: string;
    flowToken: string;
    twoFaExpirationByMinutes: number;
}

export interface PromotionPackageResponseEntity {
    response: PromotionPackageResponseCodes;
    message: string;
    flowToken: string;
    numberOfTriesLeft: number;
    customersContacts: PromotionPackageCustomerContactEntity[];
    promotionPackage: PromotionPackageEntity;
}

export interface CreatePriceOfferResponseEntity {
    response: PromotionPackageResponseCodes;
    message: string;
    flowToken: string;
    // "1"-email | "2"-sms per DeliveryMethodTypes
    deliveryMethodId: string;
    addressingId: string;
}
